import { useEffect, useState } from 'react';
import { Api } from '../../../componentes/Api';
import { Card, CardBody,Row,Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter  } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import './Estilo.css';
import { useParams } from 'react-router-dom';
import * as moment from 'moment'



var Efectivo = 0;
var Credito = 0;
var Tarjeta = 0;
var Transferencia = 0;
var Cheque = 0;
var CostoP = 0;
var Total = 0;

const CuadreCajaPV = () => {

    const [fechaInicio, setFechaInicio] = useState(new Date());
    const [fechaFin, setFechaFin] = useState(new Date());
    const [buscarPor, setBuscarPor] = useState("fecha")
    const [ventas, setVentas] = useState([])
    const [Empresa, SetEmpresa] = useState([]);




    const buscarCuadre = () => {

        let options = { year: 'numeric', month: '2-digit', day: '2-digit' };

        //let _fechaInicio = fechaInicio.toLocaleDateString('es-PE', options)
        //let _fechaFin = fechaFin.toLocaleDateString('es-PE', options)

        let fi = moment(fechaInicio).format("YYYY-MM-DD");
        let ff = moment(fechaFin).format("YYYY-MM-DD");


        //  let response = await fetch(Api + `VentasTrans/HistorialFactura?buscarPor=${buscarPor}&fechaInicio=${_fechaInicio}&fechaFin=${_fechaFin}`)
        let response = fetch(Api + "VentasTrans/HistorialFactura/" + buscarPor + "/" + fi + "/" + ff)
            .then((response) => {
                return response.ok ? response.json() : Promise.reject(response);
            })
            .then((dataJson) => {
                var data = dataJson;
                obtenerDatosEmpresa(1)
                if (data.length >= 1) {
                    setVentas(data);

                    Credito = data.reduce((x, y) => {
                        return x + y.credito;
                    }, 0)
                    CostoP = data.reduce((x, y) => {
                        return x + y.costo;
                    }, 0)
                    Efectivo = data.reduce((x, y) => {
                        return x + y.efectivo - y.devolucion;
                    }, 0)
                    Tarjeta = data.reduce((x, y) => {
                        return x + y.tarjeta;
                    }, 0)
                    Transferencia = data.reduce((x, y) => {
                        return x + y.transferencia;
                    }, 0)
                    Cheque = data.reduce((x, y) => {
                        return x + y.cheque;
                    }, 0)
                    Total = data.reduce((x, y) => {
                        return x + y.totalPago;
                    }, 0)
                } else { setVentas([]); }
            })
    }
    useEffect(() => {
        buscarCuadre();
    }, [fechaInicio || fechaFin])


   // function currencyFormatter({ currency, value }) {
    const currencyFormatter=({ currency, value }) =>{
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            minimumFractionDigits: 2,
            currency
        })
        return formatter.format(value)
    }

    const Imprimir = () => {
    
        window.print();
     
    }
   
    //const dollar = currencyFormatter({
    //    currency: "USD",
    //   Listado.subTotal
    //})
    const obtenerDatosEmpresa = async (e) => {
        let response = await fetch(Api + "Administracion/ListaEmpresas/" + e);
        if (response.ok) {
            let data = await response.json();
            SetEmpresa(data)
        }
    }
    //<iframe
    //            src="/inventario.html"
    //            title="Contenido HTML"
    //            style={{ width: '100%', height: '500px', border: 'none' }}
    //        />
    return (
        <>
          
            <div class="containerP"  >

                <div style={{ textAlign: "center" }}><h4>{Empresa.descripcion}</h4>
                    <div style={{ fontSize: "16px" }} >  <div>{Empresa.direccion}</div>
                        <div  > RNC :{Empresa.rnc}</div>
                        <b>Tel:</b>{Empresa.telefono}  <b>Correo: </b>{Empresa.email}</div>
                </div>  <br></br>
                <div style={{ textAlign: "left", fontSize: "16px" }}>
               
                    <p class="date">Fecha Cuadre: <Input type="date" onChange={(e) => setFechaInicio(e.target.value)} value={moment(fechaInicio).format("YYYY-MM-DD")} /></p>
                    <p class="date">Fecha Impresión: <Input type="date" onChange={(e) => setFechaFin(e.target.value)} value={moment(fechaFin).format("YYYY-MM-DD")} /></p>


                </div>


                <div style={{ textAlign: "left", fontSize: "10px" }} >
                    <table class="table">
                        <tr>
                            <th>Voucher</th>
                            <th>Nombre</th>
                            <th>Valor</th>
                        </tr>
                        {ventas.map((item) => (
                            <tr key={item.facturaID}>
                                {/*<td>{moment(item.fecha).format("DD/MM/YYYY")}</td>*/}
                                <td>{item.facturaID}</td>
                                <td>{item.nombreCliente}</td>
                                <td>{item.totalPago.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                            </tr>))}
                    </table>
                </div>
                <div class="footer">
                    <div class=""  >
                        <p class="total">Total: ${Total.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</p>
                        <p class="average">Costo Promedio: ${CostoP.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</p>
                        <p class="average">Ganancia Promedio: ${(Total - CostoP).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</p>


                    </div>
                    <a class="print-button" onClick={() => Imprimir()}>Imprimir</a>

                    <br></br>
                  
                    <br></br>
                </div>


          
            </div>
        </>
        )

}
export default CuadreCajaPV;